import { NotificationType } from '../types/notification';

export const NOTIFICATION_TYPES = {
  LEAD: {
    CREATED: {
      title: 'Lead Criado',
      message: 'O lead foi criado com sucesso',
      type: 'success' as NotificationType,
    },
    UPDATED: {
      title: 'Lead Atualizado',
      message: 'As informações do lead foram atualizadas',
      type: 'info' as NotificationType,
    },
    DELETED: {
      title: 'Lead Excluído',
      message: 'O lead foi excluído com sucesso',
      type: 'info' as NotificationType,
    },
    ERROR: {
      title: 'Erro no Lead',
      message: 'Ocorreu um erro ao processar o lead',
      type: 'error' as NotificationType,
    },
  },
  PRODUCT: {
    CREATED: {
      title: 'Produto Criado',
      message: 'O produto foi criado com sucesso',
      type: 'success' as NotificationType,
    },
    UPDATED: {
      title: 'Produto Atualizado',
      message: 'As informações do produto foram atualizadas',
      type: 'info' as NotificationType,
    },
    DELETED: {
      title: 'Produto Excluído',
      message: 'O produto foi excluído com sucesso',
      type: 'info' as NotificationType,
    },
    ERROR: {
      title: 'Erro no Produto',
      message: 'Ocorreu um erro ao processar o produto',
      type: 'error' as NotificationType,
    },
  },
  CAMPAIGN: {
    CREATED: {
      title: 'Campanha Criada',
      message: 'A campanha foi criada com sucesso',
      type: 'success' as NotificationType,
    },
    UPDATED: {
      title: 'Campanha Atualizada',
      message: 'As informações da campanha foram atualizadas',
      type: 'info' as NotificationType,
    },
    DELETED: {
      title: 'Campanha Excluída',
      message: 'A campanha foi excluída com sucesso',
      type: 'info' as NotificationType,
    },
    ERROR: {
      title: 'Erro na Campanha',
      message: 'Ocorreu um erro ao processar a campanha',
      type: 'error' as NotificationType,
    },
  },
  SYSTEM: {
    ERROR: {
      title: 'Erro no Sistema',
      message: 'Ocorreu um erro no sistema',
      type: 'error' as NotificationType,
    },
    WARNING: {
      title: 'Aviso do Sistema',
      message: 'Atenção! Esta é uma mensagem de aviso',
      type: 'warning' as NotificationType,
    },
    INFO: {
      title: 'Informação do Sistema',
      message: 'Esta é uma mensagem informativa',
      type: 'info' as NotificationType,
    },
  },
}; 